<template>
  <div>
<!--    <ul class="record-list">-->
<!--      <li class="item" v-for="item in recordLists" :key="item.topicId">-->
<!--        <div class="title-box">-->
<!--          <p class="title">-->
<!--            <span class="span">[{{ item.createTime.substring(0, 10) }}]</span>-->
<!--            <span class="tit">{{ item.specialtyName }}</span>-->
<!--          </p>-->
<!--          <p class="date">-->
<!--            <span-->
<!--              class="span"-->
<!--              v-for="(item2, key) in item.topicTypeMap"-->
<!--              :key="key"-->
<!--              >{{ key }}{{ item2.questionNumber }}-->
<!--            </span>-->
<!--          </p>-->
<!--        </div>-->

<!--        <div class="link-box">-->
<!--          <el-button type="primary" class="link-btn" @click="jump(item)"-->
<!--            >重做错题</el-button-->
<!--          >-->
<!--        </div>-->
<!--      </li>-->
<!--    </ul>-->
    <ComponentCollapse
      class="collect_list"
      :activeNamesList="recordLists"
      @change="change"
    >
      <ul
        slot="collapseContent"
        class="collapse-cell"
        v-for="item in numList"
        :key="item.question_style"
      >
        <li class="item">{{ item.style_name.slice(0, -2) }}</li>
        <li class="item">{{ item.num }}</li>
        <li class="item">
          <el-button class="uni-link-btn" type="primary" @click="jump(item)"
          >重做错题</el-button
          >
        </li>
      </ul>
    </ComponentCollapse>

    <ComponentEmpty
      v-if="recordLists.length == 0"
      title="暂无错题记录"
      tips=""
    />
  </div>
</template>

<script>
import ComponentCollapse from "@/components/componentCollapseTo";
import { getErrorRecords, getErrorRecordsNum } from "@/api/record";
export default {
  name: "problem",
  components: {
    ComponentCollapse
  },
  data() {
    return {
      recordLists: [],
      numList: [],
    };
  },
  created() {
    this.getErrorRecords();
  },
  methods: {
    /**
     * 获取做题记录
     */
    async getErrorRecords() {
      const params = {
        majorUuid: this.$store.state.common.studentMajorUuid,
      };
      const res = await getErrorRecords(params);
      if (res.code === 200) {
        this.recordLists = res.result;
      }
    },
    async getNum(course_id) {
      const res = await getErrorRecordsNum({
        course_id: course_id,
      });
      if (res.code === 200) {
        this.numList = res.result.list;
      }
    },
    change(val) {
      if (val) {
        this.course_id = val;
        this.getNum(val);
      }
    },
    /**
     * 重做错题
     */
    jump(item) {
      this.$router.push({
        name: "smartPractice",
        query: {
          course_id: this.course_id,
          question_style: item.question_style,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
collect_list {
  /deep/ .header {
    background-color: #f8f9fb;
  }
}
.collapse-cell {
  display: flex;
  align-items: center;
  padding: 20px 20px 20px 70px;

  .iconfont {
    vertical-align: middle;
    font-size: 20px;
    margin-right: 10px;
  }

  .item {
    flex: 1;
    text-align: center;
    &:nth-child(1) {
      text-align: left;
      flex: 2;
    }
  }

  .uni-link-btn {
    @include uni-link-btn(90px);
    margin-left: 40px;
  }
}
</style>
